// extracted by mini-css-extract-plugin
module.exports = {"languageSelect":"language-select_languageSelect__1kMDN","invalidate":"language-select_invalidate__3vrZV"};